import { memo } from 'react'

function SubmitButton({ isSubmit, wFit, allowToEnter = true }) {
  return (
    <button
      disabled={isSubmit || !allowToEnter}
      className={`flex items-center justify-center gap-2 rounded-md py-2.5 
            ${wFit ? 'w-fit px-4 mx-auto' : 'w-3/4 mr-1'}
            ${!allowToEnter ? 'bg-rose-300' : 'bg-blue'}
             hover:shadow-lg ease-linear transition-all duration-150`}
      type="submit"
    >
      {!allowToEnter ? (
        <span className={'text-white'}>اطلاعات نا معتبر است</span>
      ) : isSubmit ? (
        <span className={'text-white'}>در حال بررسی</span>
      ) : (
        <>
          <span className={'text-white'}>ثبت اطلاعات</span>
          <i className={'icon-arrow-left text-white text-lg'} />
        </>
      )}
    </button>
  )
}

export default memo(SubmitButton)
